import api from '@/plugins/api'

const state = {
  examRounds: [],
  loading: false,
  error: null
}

const mutations = {
  SET_EXAM_ROUNDS(state, examRounds) {
    state.examRounds = examRounds
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

const actions = {
  async fetchExamRounds({commit}, params = {}) {
    commit('SET_LOADING', true)
    try {
      const response = await api.ExamRound.fetch(params)
      const examRounds = Array.isArray(response) ? response : response.data || []
      commit('SET_EXAM_ROUNDS', examRounds)
      return examRounds
    } catch (error) {
      commit('SET_ERROR', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async createExamRound({commit}, data) {
    commit('SET_LOADING', true)
    try {
      return await api.ExamRound.create(data)
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async updateExamRound({commit}, {id, data}) {
    commit('SET_LOADING', true)
    try {
      return await api.ExamRound.update(id, data)
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async setCurrentExamRound({commit}, {grade, id}) {
    commit('SET_LOADING', true)
    try {
      return await api.ExamRound.setCurrent({grade, id})
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async deleteExamRound({commit}, id) {
    commit('SET_LOADING', true)
    try {
      return await api.ExamRound.remove(id)
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  examRounds: state => state.examRounds,
  examRoundsLoading: state => state.loading
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
